export default "__VITE_ASSET__424b32f7__"